export const profile = {
  profileFavoritesIconTitle: 'Preferiti',
  profileEditIconTitle: 'Modifica',
  profileShareIconTitle: 'Condividi',
  profileAdditionalSectionTitle: 'Informazioni aggiuntive',
  profileFavoritesCurtainTitle: 'Preferiti',
  profileFavoriteActionTitle: 'Aggiungi ai preferiti',
  profileFavoritedActionTitle: 'Aggiunto ai preferiti',
  profileMessageAction: 'Messaggio',
  profileCurtainAdd: 'Aggiungi',
  profileReportUser: 'Segnala utente',
  profileReportTitle: 'Segnala',
  profileReportSuccess: 'Contenuto segnalato',
  profileReset: 'Ripristina',
  profileApply: 'Applica',
  profileCustomInvalidEmail: 'non è un indirizzo email valido',
  profileMaxContentSizeError: 'Hai superato la dimensione massima del contenuto!',
  profileMaxAvatarSizeError: 'La dimensione del tuo avatar è troppo grande!',
  profileFavoritesCurtainSearchInputText: 'Cerca',
  profileTapShareCurtainOptionTitle: 'Copia link',
  profileTapShareLinkCopiedAlertTitle: 'Link copiato!',
  profileQrShareCurtainTitle: 'Condividi il Profilo',
  profileQrShareCurtainShareButtonTitle: 'Condividi',
  profileQrShareCurtainCopyButtonTitle: 'Copia link',
  profileQrShareCurtainCopiedAlertTitle: 'Link copiato!',
  profileQrTapShareProfileCurtainTitle: 'Condividi il tuo Profilo',
  profileEditTitle: 'Modifica',
  profileEditPersonalSectionTitle: 'Dati personali',
  profileEditContactsSectionTitle: 'Contatti',
  profileEditSocialSectionTitle: 'Social',
  profileEditAddSocialButtonTitle: 'Aggiungi social media',
  profileEditAdditionalSectionTitle: 'Informazioni aggiuntive',
  profileEditSaveButtonTitle: 'Salva',
  profileEditSavedAlertTitle: 'Profilo salvato!',
  profileEditEmptyRequiredInputTitle: 'Il valore non può essere vuoto',
  profileEditEmptyRequiredEmailInputTitle: "L'email pubblica non è un indirizzo valido",
  profileEditEmptyRequiredErrorTitle: 'Qualcosa è andato storto!',
  profileEditSocialsHint: "Inserisci l'URL del tuo profilo sociale",
  preferences: 'Preferenze',
  interestedIn: 'Interessato a',
  expertIn: 'Sono un esperto in',
  myPitch: 'Il mio pitch',
  qrBadge: 'Badge QR',
  touchpoints: 'Touchpoints',
  lookingFor: 'Sto cercando',
  topicsToDiscuss: 'Argomenti da discutere',
  createNew: 'Crea nuovo',
  viewTopic: 'Visualizza argomento',
  hobbyInterests: 'Hobby e interessi',
  myNetwork: 'La mia rete',
  seeAll: 'Vedi tutto',
  checkThemOut: 'Scoprili!',
  activities: 'Attività',
  oneOnOne: 'Incontro 1:1',
  Leaderboard: 'Classifica',
  learnNetworking: 'Scopri di più su Networking Hub',
  networkingGroup: 'Gruppo di networking',
  networkingLevel: 'Livello di networking',
  addNote: 'Aggiungi nota',
  notes: 'Note',
  enterNote: 'Inserisci una nota',
  shareUserProfile: 'Condividi il profilo utente',
  flagUser: 'Segnala utente'
}
